import "./index.css";
import { useContext } from "react";
import { NavContext } from "../../App";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUserModules } from "../UserModuleContext";
import companyIcon from "../../assets/icons-tabs/company-icon.svg";
import productIcon from "../../assets/icons-tabs/wrench-icon.svg";
import ambitionIcon from "../../assets/icons-tabs/ambition-icon.svg";
import reportIcon from "../../assets/icons-tabs/report-icon.svg";
import mapIcon from "../../assets/icons-tabs/map-icon.svg";
import profileIcon from "../../assets/icons-tabs/profile_icon.svg";
import aboutIcon from "../../assets/icons-tabs/about-icon.svg";
import feedIcon from "../../assets/icons-tabs/feed-icon.svg";
import educationIcon from "../../assets/icons-tabs/education-icon.svg";
import clientIcon from "../../assets/icons-tabs/client-icon.svg";
import shareIcon from "../../assets/icons-tabs/share-icon.svg";
import locked from "../../assets/locked.svg";

const withAccessControl = (WrappedComponent) => {
  return ({ moduleName, ...props }) => {
    const { isModuleAccessible } = useUserModules();

    const isLocked = moduleName ? !isModuleAccessible(moduleName) : false;

    return <WrappedComponent {...props} isLocked={isLocked} />;
  };
};

export const NavigationStyle1 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "130px",
          height: "120px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style1" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "10px" }}>
            <img src={educationIcon} alt="Education Icon" />
          </div>
        )}
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle2 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style2" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={productIcon} alt="Product Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle3 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "190px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style3" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={companyIcon} alt="Company Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle4 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "180px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style4" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={ambitionIcon} alt="Ambition Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle5 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style5" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={reportIcon} alt="Report Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle6 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "173px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style6" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
        {selected && (
          <div style={{ marginLeft: "20px" }}>
            <img src={feedIcon} alt="Feed Icon" />
          </div>
        )}
      </div>
    );
  }
);

export const NavigationStyle7 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "173px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style7" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
        {selected && (
          <div style={{ marginLeft: "20px" }}>
            <img src={profileIcon} alt="Profile Icon" />
          </div>
        )}
      </div>
    );
  }
);

export const NavigationStyle8 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "173px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style8" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
        {selected && (
          <div style={{ marginLeft: "20px" }}>
            <img src={aboutIcon} alt="About Us Icon" />
          </div>
        )}
      </div>
    );
  }
);

export const NavigationStyle11 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style11" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={mapIcon} alt="Map Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle12 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style12" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={clientIcon} alt="Client Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle13 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style13" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={shareIcon} alt="Share Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

const Navigation = () => {
  const [nav, setNav] = useContext(NavContext);
  const { t } = useTranslation();
  const { isModuleAccessible } = useUserModules();

  const handleNav = (number) => {
    setNav(number);
    window.scrollTo(0, 0);
    document.getElementsByTagName("body")[0].className = "";
  };

  return (
    <>
      <div className="company__navigation d-flex position-sticky justify-content-between">
        <div
          className="company__navigation__left d-flex"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <div className="d-flex">
            <Link
              className="nav-link"
              to="/company"
              style={{
                pointerEvents: !isModuleAccessible("Company") ? "none" : "auto",
              }}
            >
              <NavigationStyle3
                moduleName="Company"
                text={t("COMPANY")}
                setNav={() => handleNav(3)}
                style={{
                  position: "relative",
                  left: "-5px",
                  display: "flex",
                  flexDirection: "column",
                }}
                selected={
                  window.location.pathname.startsWith("/company") ? true : false
                }
              />
            </Link>
            <Link
              className="nav-link"
              to="/product"
              style={{
                pointerEvents: !isModuleAccessible("Product") ? "none" : "auto",
              }}
            >
              <NavigationStyle2
                moduleName="Product"
                text={t("PRODUCT")}
                setNav={() => handleNav(2)}
                style={{ position: "relative", left: "-17px" }}
                selected={
                  window.location.pathname.startsWith("/product") ||
                  window.location.pathname.startsWith("/service")
                    ? true
                    : false
                }
              />
            </Link>
            {/* <Link
              className="nav-link"
              to="/client"
              style={{
                pointerEvents: !isModuleAccessible("Client") ? "none" : "auto",
              }}
            >
              <NavigationStyle12
                moduleName="Client"
                text={t("CLIENT")}
                setNav={() => handleNav(12)}
                style={{ position: "relative", left: "-25px" }}
                selected={
                  window.location.pathname.startsWith("/client") ? true : false
                }
              />
            </Link> */}
            <Link
              className="nav-link"
              to="/ambition"
              style={{
                pointerEvents: !isModuleAccessible("Ambition")
                  ? "none"
                  : "auto",
              }}
            >
              <NavigationStyle4
                moduleName="Ambition"
                text={t("AMBITION")}
                setNav={() => handleNav(4)}
                style={{ position: "relative", left: "-30px" }}
                selected={
                  window.location.pathname.startsWith("/ambition")
                    ? true
                    : false
                }
              />
            </Link>

            <Link
              className="nav-link"
              to="/reporting"
              style={{
                pointerEvents: !isModuleAccessible("Report") ? "none" : "auto",
              }}
            >
              <NavigationStyle5
                moduleName="Report"
                text={t("REPORT")}
                setNav={() => handleNav(5)}
                style={{ position: "relative", left: "-40px" }}
                selected={
                  window.location.pathname.startsWith("/reporting")
                    ? true
                    : false
                }
              />
            </Link>
          </div>
          {/* <div className="d-flex">
            <Link
              className="nav-link"
              to="/share"
              style={{
                pointerEvents: !isModuleAccessible("Share") ? "none" : "auto",
              }}
            >
              <NavigationStyle13
                moduleName="Share"
                text={t("SHARE_TAB")}
                setNav={() => handleNav(13)}
                style={{ position: "relative", right: "20px" }}
                selected={
                  window.location.pathname.startsWith("/share") ? true : false
                }
              />
            </Link>
            <Link
              className="nav-link"
              to="/waste-map"
              style={{
                pointerEvents: !isModuleAccessible("Map") ? "none" : "auto",
              }}
            >
              <NavigationStyle11
                moduleName="Map"
                text={"Map"}
                setNav={() => handleNav(11)}
                style={{ position: "relative", right: "30px" }}
                selected={
                  window.location.pathname.startsWith("/waste-map")
                    ? true
                    : false
                }
              />
            </Link>
          </div> */}
        </div>
        <div
          className="company__navigation__right"
          style={{ display: "absolute", flexDirection: "column" }}
        >
          <Link
            className="nav-link"
            to="/profile"
            style={{
              pointerEvents: !isModuleAccessible("Profile") ? "none" : "auto",
            }}
          >
            <NavigationStyle7
              moduleName="Profile"
              text={t("PROFILE")}
              setNav={() => handleNav(7)}
              style={{ position: "absolute", right: "-123px", top: "130px" }}
              selected={
                window.location.pathname.startsWith("/profile") ? true : false
              }
            />
          </Link>
          <Link
            className="nav-link"
            to="/about"
            style={{
              pointerEvents: !isModuleAccessible("About") ? "none" : "auto",
            }}
          >
            <NavigationStyle8
              moduleName="About"
              text={t("ABOUT_YFS")}
              setNav={() => handleNav(8)}
              style={{ position: "absolute", right: "-123px", top: "210px" }}
              selected={
                window.location.pathname.startsWith("/about") ? true : false
              }
            />
          </Link>
          <Link
            className="nav-link"
            to="/feed"
            style={{
              pointerEvents: !isModuleAccessible("Feed") ? "none" : "auto",
            }}
          >
            <NavigationStyle6
              moduleName="Feed"
              text={t("FEED")}
              setNav={() => handleNav(6)}
              style={{ position: "absolute", right: "-123px", top: "330px" }}
              selected={
                window.location.pathname.startsWith("/feed") ? true : false
              }
            />
          </Link>
          <Link
            className="nav-link"
            to="/education"
            style={{
              pointerEvents: !isModuleAccessible("Education") ? "none" : "auto",
            }}
          >
            <NavigationStyle1
              moduleName="Education"
              text={t("EDUCATION")}
              setNav={() => handleNav(1)}
              style={{ position: "absolute", right: "-123px", top: "410px" }}
              selected={
                window.location.pathname.startsWith("/education") ? true : false
              }
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default Navigation;
